<template>
    <div class="mark-c2p" ref="rootElement" @click="$emit('click')">
        <src-mark
            :card-brands="cardBrands"
            :height="height"
            :width="width >= 178? width: 178"
        />
    </div>
</template>

<script>
import { logException } from '@/helpers/cieloLogger';

export default {
    watch: {
        justify(newValue) {
            this.applyCustomJustify(newValue);
        },
        width() {
            this.applyCustomWidth(true);
        },
        forceWidth() {
            this.applyCustomWidth(true);
        },
    },

    async mounted() {
        await this.applyCustomJustify(this.justify);
        await this.applyCustomWidth(false);
    },

    props: {
        cardBrands: {
            type: Array,
            default: () => []
        },
        height: {
            type: Number,
            default: 40,
        },
        width: {
            type: Number,
            default: 200,
        },
        forceWidth: {
            type: Boolean,
            default: false,
        },
        justify: {
            type: String,
            default: '',
        }
    },

    methods: {
        async applyCustomJustify(value) {
            try {
                let rootElement = this.$refs.rootElement;

                await customElements.whenDefined('src-mark');

                const markElement = rootElement.querySelector('src-mark');
                const sheet = new CSSStyleSheet;
                sheet.replaceSync( `.button-inside { 
                    justify-content: ${value} !important; 
                }`);
                markElement.shadowRoot.adoptedStyleSheets.push(sheet);
            } catch (error) {
                logException(error);
            }
        },

        async applyCustomWidth(replaceStyle) {
            try {
                let rootElement = this.$refs.rootElement;
                await customElements.whenDefined('src-mark');

                const markElement = rootElement.querySelector('src-mark');

                if(replaceStyle) {
                    markElement.shadowRoot.adoptedStyleSheets = [
                        ...markElement.shadowRoot.adoptedStyleSheets
                    ].filter(sheet => sheet.id !== 'custom-width-sheet');
                }

                if(!this.forceWidth) {
                    return;
                }

                const sheet = new CSSStyleSheet;
                sheet.id = 'custom-width-sheet';
                sheet.replaceSync( `button.dark { 
                    min-width: ${this.width}px !important; 
                    width: ${this.width}px !important;
                }`);
                markElement.shadowRoot.adoptedStyleSheets.push(sheet);
            } catch (error) {
                logException(error);
            }
        }
    },
};
</script>

<style lang="css" scoped>

</style>